import adminActions from "./adminActions";
import operatorActions from "./operatorActions";
import userActions from "./userActions";
import operatorBuhgalterActions from "./operatorBuhgalterActions";

const state = {
    data: {},
    documents: [],
    accounts: {},
    certificate: {},
    loading: false,
    accountsLoading: false,
    error: false,
};

const mutations = {
    setDocuments: (state, documents) => (state.documents = documents),
    setAccounts: (state, accounts) => (state.accounts = accounts),
    setCertificate: (state, certificate) => (state.certificate = certificate),
    setLoading: (state, status = true) => (state.loading = status),
    setAccountsLoading: (state, status = true) => (state.accountsLoading = status),
    setError: (state, error) => (state.error = error),
    setData(state, data) {
        const {email, id, name, step, role, blocked, profile_label, pass_req} = data;
        state.data = {
            ...data.profile,
            email,
            id,
            name,
            step,
            blocked,
            profile_label,
            role,
            pass_req,
        };
    },
};

const actions = {
    ...userActions,
    ...operatorActions,
    ...operatorBuhgalterActions,
    ...adminActions,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
